import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

@observer
export class LoadingIndicator extends React.Component {

	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		isLoading: PropTypes.bool.isRequired,
	};

	render() {
		return (
			<div className="loading-indicator-wrapper">
				{this.props.isLoading &&
					(<div className="row">
						<div className="loading-container col-12">
							<h2><i className="icon-reload"></i>Loading&hellip;</h2>
						</div>
					</div>)
				}
				{this.props.children}
			</div>
		);
	}
}